import { render, staticRenderFns } from "./TwInputFormatNumber.vue?vue&type=template&id=29508baa&"
import script from "./TwInputFormatNumber.vue?vue&type=script&lang=js&"
export * from "./TwInputFormatNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports